import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { motion, useReducedMotion } from "framer-motion";
import { ArrowUp } from "lucide-react";
import Lenis from "lenis";
import { Header } from "./Header";
import { Footer } from "./Footer";

const BackToTop = () => {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 800);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      data-testid="back-to-top-button"
      aria-label="Back to top"
      className={`btt fixed bottom-6 right-6 z-[95] w-11 h-11 border border-line bg-ink-2/90 backdrop-blur flex items-center justify-center text-steel hover:bg-amber-brand hover:text-ink hover:border-amber-brand ${visible ? "opacity-100" : "opacity-0 pointer-events-none"}`}
    >
      <ArrowUp size={18} />
    </button>
  );
};

export const Layout = () => {
  const { pathname } = useLocation();
  const reduce = useReducedMotion();

  useEffect(() => {
    if (reduce) return;
    const lenis = new Lenis({ autoRaf: true, lerp: 0.11 });
    return () => lenis.destroy();
  }, [reduce]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="grain min-h-screen flex flex-col bg-ink">
      <a href="#main-content" className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[200] focus:bg-amber-brand focus:text-ink focus:px-4 focus:py-2 font-mono-tech text-sm">
        Skip to content
      </a>
      <Header />
      <motion.main
        id="main-content"
        key={pathname}
        initial={reduce ? false : { opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
        className="flex-1"
      >
        <Outlet />
      </motion.main>
      <Footer />
      <BackToTop />
    </div>
  );
};
